module.exports = __webpack_public_path__ + "static/media/happy-ending.7e57e70c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/happy-ending.mp3
// module id = 1535
// module chunks = 1